import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useRatings(coachId) {
  const [ratings, setRatings] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.coaches.ratings.index(coachId))
      .then((response) => {
        setRatings(response.data.data);
      });
  }, []);

  return ratings;
}
